import React from 'react';
import { View as RNView, Text as RNText, Image as RNImage, TouchableOpacity, TextInput } from 'react-native-web';

import styleBase, { buildStyles } from '../../helpers/styles-core';

import { observer } from 'mobx-react';

export { TextInput };

function prepStyles(props, defaults, islog) {
  const { style, styles = '' } = props;
  const styleStr = defaults ? defaults + styles : styles;
  const stylesArr = buildStyles(styleStr, styleBase);
  if (islog) {
    console.log('PREP', styles, defaults, styleStr, stylesArr);
  }
  if (style) {
    stylesArr.push(style);
  }
  return stylesArr;
}

export function View(props) {
  if (!process.env.BROWSER) {
    return null;
  }
  const stylesArr = prepStyles(props);

  const { styles, ...rest } = props;
  return (
    <RNView style={stylesArr} {...rest}>
      {'if' in props ? (props.if ? props.children : null) : props.children}
    </RNView>
  );
}

export function TouchableView(props) {
  const stylesArr = prepStyles(props);

  const { styles, ...rest } = props;
  return (
    <TouchableOpacity style={stylesArr} {...rest}>
      {props.if !== undefined ? (props.if ? props.children : null) : props.children}
    </TouchableOpacity>
  );
}

export function Text(props) {
  if (!process.env.BROWSER) {
    return null;
  }
  const stylesArr = prepStyles(props, 'proxima-nova t gray-dark-medium ');
  const { styles, ...rest } = props;
  // console.log('TEXT STYLES', styles, stylesArr);
  return (
    <RNText style={stylesArr} {...rest}>
      {props.children}
    </RNText>
  );
}

RNText.defaultProps = RNText.defaultProps || {};
RNText.defaultProps.allowFontScaling = false;
TextInput.defaultProps = TextInput.defaultProps || {};
TextInput.defaultProps.allowFontScaling = false;

export function Image(props) {
  const stylesArr = prepStyles(props, 'f-1 j-self-center');
  const { styles, ...rest } = props;
  // console.log('Image STYLES', styles, stylesArr);
  return (
    <RNImage style={stylesArr} {...rest}>
      {props.children}
    </RNImage>
  );
}

export function ImageRaw(props) {
  const stylesArr = prepStyles(props, 'h-null w-null ');
  const { styles, ...rest } = props;
  // console.log('Image STYLES', styles, stylesArr);
  return (
    <RNImage style={stylesArr} {...rest}>
      {props.children}
    </RNImage>
  );
}

export const TextButton = observer(props => {
  const { secondary, styles, textStyles, ...rest } = props;
  let btnStyles = 'btn btn-primary sh-default ';
  let tStyles = 'h6 btn-text ';
  if (secondary) {
    btnStyles = 'btn btn-secondary sh-default ';
  }
  const stylesArr = prepStyles(props, btnStyles);
  const textStylesArr = prepStyles({}, tStyles + textStyles);

  textStylesArr.push({ textAlign: 'center' });
  if (props.disabled) {
    textStylesArr.push({ opacity: 0.5 });
  }
  return (
    <TouchableOpacity style={stylesArr} {...rest}>
      <Text style={textStylesArr}>{props.children}</Text>
    </TouchableOpacity>
  );
});

export function LinkButton(props) {
  const { secondary, styles, textStyles, ...rest } = props;
  let btnStyles = '';
  let tStyles = 'h6 primary ';
  const stylesArr = prepStyles(props, btnStyles);
  const textStylesArr = prepStyles({}, tStyles + textStyles);

  textStylesArr.push({ textAlign: 'center' });
  return (
    <TouchableOpacity style={stylesArr} {...rest}>
      <Text style={textStylesArr}>{props.children}</Text>
    </TouchableOpacity>
  );
}

export function Button(props) {
  const { styles, ...rest } = props;
  const stylesArr = prepStyles(props, styles);

  // console.log('Button STYLES', stylesArr);
  return (
    <TouchableOpacity style={stylesArr} {...rest}>
      {props.children}
    </TouchableOpacity>
  );
}



// WEBPACK FOOTER //
// ./src/components_new/react-native/reactNativeWrappers.js